import React, { useState }           from 'react';
import { Container, Grid, SimpleGrid, useMantineTheme } from '@mantine/core';
import { DXBImageView }                                 from '@features/common/DXBImageView';
import { ImageGalleryModal }                            from '@features/property-details/components/Gallery/ImageGalleryModal';
import { S3_PROPERTY_BUCKET_URL }                       from '@utils/network-utils';
import { usePropertyState } from "@core/providers/PropertyStateProvider";

import useStyles                                        from './DetailsGallery.styles';


export const DetailsGallery: React.FC = () => {

    // const mountLock = useRef(true)
    const { classes } = useStyles();
    const theme = useMantineTheme();

    const { getGalleryFrontImages, findImageIndex } = usePropertyState();

    // CALCULATIONS
    const PRIMARY_COL_WIDTH = 576;
    const PRIMARY_COL_HEIGHT = PRIMARY_COL_WIDTH / 1.5;
    const SECONDARY_COL_HEIGHT = PRIMARY_COL_WIDTH / 1.5 - theme.spacing.md / 2;

    // GALLERY
    const [showImageGalleryModal, setShowImageGalleryModal] = useState(false);

    const PreviewImage = ({ src, alt, width, height }) => (
        <DXBImageView
            onClick={() => {

                findImageIndex(alt);

                setShowImageGalleryModal(true);

                // console.log(image, 'ASIM')
            }}
            width={width}
            height={height}
            src={`${S3_PROPERTY_BUCKET_URL}/${src}`}
            alt={alt}
            priority={true}
            className={classes.imageStyles}
        />
    )

    const frontSecondaryImages = getGalleryFrontImages()
        .slice(1, getGalleryFrontImages().length)
        .map((image, idx) => {
            return (
                <Grid.Col span={6} key={idx}>
                    <PreviewImage
                            src={image.src}
                            alt={image.alt}
                            width={PRIMARY_COL_WIDTH}
                            height={SECONDARY_COL_HEIGHT}
                        />
                </Grid.Col>
            )
        })

    return (
        <Container my="md" className={classes.galleryContainer} mt={20} mb={20} m={0} p={0}>

            {
                showImageGalleryModal &&
                <ImageGalleryModal
                    open={showImageGalleryModal}
                    onClose={() => {
                        setShowImageGalleryModal(false);
                    }}
                />
            }

            <SimpleGrid cols={2} breakpoints={[{ maxWidth: 'sm', cols: 1 }]}>

                {
                    getGalleryFrontImages()?.[0]?.src &&
                    <PreviewImage
                        src={getGalleryFrontImages()[0]?.src}
                        alt={getGalleryFrontImages()[0].alt}
                        width={PRIMARY_COL_WIDTH}
                        height={PRIMARY_COL_HEIGHT}
                    />
                }

                <Grid gutter="md">

                    {frontSecondaryImages}

                </Grid>

            </SimpleGrid>

        </Container>
    )

}
